import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import "./question.css";

const QuestionSF = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40">FAQs</h2>
      <Row className="p-4">
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="0"
              onClick={() => handleToggle("0")}
            >
              <Accordion.Header as="h3" className="red-header">
                What is composite bonding, and how does it work?
              </Accordion.Header>
              <Accordion.Body>
                Composite bonding is a cosmetic dental treatment that uses a
                tooth-coloured resin material to repair chips, cracks, gaps, or
                discolouration and enhance the appearance of teeth. The resin is
                applied, shaped, and hardened with a special light, resulting in
                a natural-looking finish.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header as="h3" className="red-header">
                How long does composite bonding last?
              </Accordion.Header>
              <Accordion.Body>
                With proper care, composite bonding can last between 5 and 10
                years. Its durability depends on factors such as oral hygiene,
                diet, and habits like teeth grinding or biting on hard objects.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header as="h3" className="red-header">
                Is composite bonding painful?
              </Accordion.Header>
              <Accordion.Body>
                Composite bonding is typically a painless procedure and often
                does not require anaesthetic. The tooth surface is lightly
                prepared, and the resin is applied without causing discomfort.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="7"
              onClick={() => handleToggle("7")}
            >
              <Accordion.Header as="h3" className="red-header">
                Who can benefit from composite bonding?
              </Accordion.Header>
              <Accordion.Body>
                Anyone who has any slight imperfections with the size, shape or
                colour of their teeth can get a lovely new smile using composite
                bonding.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="8"
              onClick={() => handleToggle("8")}
            >
              <Accordion.Header as="h3" className="red-header">
                How much does composite bonding cost?
              </Accordion.Header>
              <Accordion.Body>
                Composite bonding costs as little as £350 per tooth but we
                always suggest coming in for a consultation so we can assess
                your smile and give you an accurate quotation.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header as="h3" className="red-header">
                Can composite bonding close gaps between teeth?
              </Accordion.Header>
              <Accordion.Body>
                Yes, composite bonding is an effective way to close small gaps
                between teeth. It can improve the appearance of your smile
                without the need for orthodontic treatment.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header as="h3" className="red-header">
                How should I care for my teeth after composite bonding?
              </Accordion.Header>
              <Accordion.Body>
                To maintain your composite bonding, practice good oral hygiene,
                avoid staining foods and drinks like tea, coffee, and red wine,
                and refrain from biting hard objects. Regular dental check-ups
                and cleanings are also important.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="9"
              onClick={() => handleToggle("9")}
            >
              <Accordion.Header as="h3" className="red-header">
                Who is a good candidate for composite bonding?
              </Accordion.Header>
              <Accordion.Body>
                Composite bonding is ideal for people with minor cosmetic
                concerns, such as chipped, discoloured, or uneven teeth.
                However, it may not be suitable for those with significant
                dental issues or underlying oral health problems. A consultation
                with your dentist can help determine if it's the right treatment
                for you.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="10"
              onClick={() => handleToggle("10")}
            >
              <Accordion.Header as="h3" className="red-header">
                Can composite bonding repair chipped or broken teeth?
              </Accordion.Header>
              <Accordion.Body>
                Yes! Composite bonding is the most cost effective solution to
                repairing chipped or broken teeth.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionSF;
